<template>
  <div>

    <section>
      <div class="container-fluid my-5">
        <div class="pl-3 pl-xl-4">
          <p class="mb-0 movieTheatreTitlel">Capitol Theatre</p>
          <p class="movieTheatreAdd">13, Stamford Street</p>
        </div>
      </div>
    </section>


    <section class="bg-light py-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 pl-3 pl-xl-4">
            <Slick :options="dateTimeSlider">
              <div v-for="(ssImg, ssImages) in 20" :key="ssImages">
                <div class="dtSlider-container">
                  <div class="dt-box">
                    <p class="month">Sep</p>
                    <p class="date">05</p>
                    <p class="day">Wed</p>
                  </div>
                </div>
              </div>
            </Slick>
          </div>


          <div class="col-md-6 text-md-right movieDetails-drop d-none">
            <b-dropdown id="ddown-left" text="Show Type: All" variant="default" class="m-2">
              <b-dropdown-item href="#">Action</b-dropdown-item>
              <b-dropdown-item href="#">Another action</b-dropdown-item>
              <b-dropdown-item href="#">Something else here</b-dropdown-item>
            </b-dropdown>
            <b-dropdown id="ddown-right" right text="Filter By (Price, Show time)" variant="default" class="m-2">
              <b-dropdown-item href="#">Action</b-dropdown-item>
              <b-dropdown-item href="#">Another action</b-dropdown-item>
              <b-dropdown-item href="#">Something else here</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </section>



    <section>
      <div class="container-fluid my-5">
        <!-- SECTION START -->
        <div class="mb-4" v-for="(showTime, st) in 2" :key="st">
          <div class="row">
            <div class="col-md-3 pl-3 pl-xl-5">
              <p class="mb-0 movieTheatreTitles">Capitol Theatre</p>
              <p class="movieTheatreAdd">13, Stamford Street</p>
            </div>

            <div class="col-md-9">
              <div class="movie-timing">
                <div class="m-format redRightLine">
                  <span>2D</span>
                </div>
                <div class="timing-box">
                  <ul class="timing-box-list">
                    <li class="" v-for="(mTime, mT) in 15" :key="mT">
                      09.00 AM
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr class="bottomRedLine grey">
        </div>
        <!-- SECTION START END-->
      </div>
    </section>




 <!-- SPECIAL SCREENINGS CREATE SLIDES -->
    <section class="bg-light py-5">
      <div class="container-fluid my-4 csCusSlider">
        <Slick :options="movieSlider">
        <div v-for="(ssImg, ssImages) in 2" :key="ssImages">
            <div class="movieSlider-container mx-auto text-center">
                <div class="img-container">
                    <router-link to="">
                        <img src="@/assets/img/movieposter1.jpg" alt="" class="img-fluid mx-auto banner">
                    </router-link>

                    <div class="img-text py-2">
                        <p class="mb-0"><span>3</span> Screenings</p>
                    </div>
                </div>            
                <div class="text-center mx-auto pt-3 movieSliderInfo">
                    <p class="mb-0 title">Johnny English Strikes</p>
                    <ul class="list-inline mb-0 mInfo">
                        <li class="list-inline-item">2018</li>
                        <li class="list-inline-item">|</li>
                        <li class="list-inline-item">PG13</li>
                    </ul>
                </div>
            </div>
        </div>
       <div>
            <div class="movieSlider-container mx-auto text-center">
                <div class="addSlide-container">
                    <router-link to="">
                        <img src="@/assets/img/movieposter1.jpg" alt="" class="img-fluid mx-auto">
                    </router-link>

                    <div class="addSlide">
                        <span><img src="@/assets/img/svg/gogo-add-icon.svg" class="img-fluid addImg"></span>
                        <p class="mb-0 pt-2">Create Your Own Screening</p>
                    </div>
                </div> 
            </div>
        </div>
       </Slick>
      </div>
    </section>



    <!-- NOW SHOWING MOVIES SLIDER -->
    <section>
      <div class="container-fluid my-4">
        <NowShowing />
      </div>
    </section>


    <!-- CREATE YOUR OWN SCREENING SLIDER -->
    <section>
      <div class="container-fluid my-4">
        <OwnScreening />
      </div>
    </section>

  </div>
</template>

<script>
  import Slick from "vue-slick";

  import NowShowing from "@/components/partials/nowShowingSlider.vue";
  //   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
  import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
  //   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";


  export default {
    name: 'searchResult',
    directives: {
      // 'dragscroll': dragscroll
    },
    components: {
      Slick,
      OwnScreening,
      NowShowing
    },

    data() {
      return {
        dateTimeSlider: {
          dots: false,
          infinite: false,
          speed: 300,
          arrows: false,
          slidesToShow: 9,
          slidesToScroll: 6,
          dots: false,
          responsive: [{
              breakpoint: 1900,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 4,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3.1,
                slidesToScroll: 3,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2
              }
            }
          ]
        },
        movieSlider: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 5.5,
          slidesToScroll: 4,
          dots: false,
          responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 3,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        },
      }
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/pages/searchResultCinema.vue